// 兼容 IE
import 'babel-polyfill'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)
import TruelandUI from 'trueland-ui'
Vue.use(TruelandUI)
import App from './App.vue'
import axios from 'axios'
import bus from '@/utils/bus'
import {showtipFunAjx} from '@/utils/index'
// import './assets/icon/iconfont.css' 本地引入的图标要备注掉，使用在线的，不然改一次图标发一次版？
import '@/styles/index.scss'
import router from './router'
import store from './store'
import './utils/error-log'
// import '@/assets/icon/iconfont.css'

import '@dhr/dhrforce-ui/lib/style/pc.css'
import dhrforceUI from '@dhr/dhrforce-ui'
import VueClipboard from 'vue-clipboard2'
// import '@/utils/echartUtils.js' // echart按需引入，优化打包体积
Vue.use(VueClipboard)
Vue.use(dhrforceUI.CustomSvgIcon)
Vue.use(dhrforceUI.DhrNotificationPc)
// import '@/assets/icon/iconfont.css'
// import VueTribute from 'vue-tribute'
// Vue.use(VueTribute)
import { getInstanceName, hasPermission, isNoShowPermission, isDisabledPermission } from '@/utils/instanceName'
Vue.prototype.$getInstanceName = getInstanceName
Vue.prototype.$hasPermission = hasPermission
Vue.prototype.$isNoShowPermission = isNoShowPermission
Vue.prototype.$isDisabledPermission = isDisabledPermission
import { preventReClick } from '@/utils/preventReClick' // 指令
Vue.use(preventReClick)
import { loadmore } from '@/utils/loadmore' // 指令
Vue.use(loadmore)
import TooltopDirectve from '@/utils/tooltip'
Vue.directive('tooltip', TooltopDirectve)
import richText from 'site_rich_text'
import 'site_rich_text/lib/site_rich_text.css'
Vue.use(richText)
import Component from '@/components/comComponents'
Vue.use(Component) // 注册全局组件
// 海报组件注册
import Style_list_config from './base/style_list_config'
window.Style_list_config = Style_list_config
import Public from './base/public'
import utils from './base/utils'
Vue.prototype.templet = new Public()
Vue.prototype.utils = utils
import confirmDialog from '@/components/confirmDialog/index'
Vue.prototype.$confirmDialog = confirmDialog
// vue-easy-tree
import VueEasyTree from "@wchbrad/vue-easy-tree";
Vue.use(VueEasyTree)

import 'xe-utils'
import {
  VXETable,
  // 按需引入需要的组件
  Table,
  Column,
  // ... 其他组件
} from 'vxe-table'
import 'vxe-table/lib/style.css'

Vue.use(VXETable).use(Table).use(Column)

// 滚动加载更多
Vue.directive('loadMore', {
  bind(el, binding) {
    // 获取element，定义scroll
    const select_dom = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    select_dom.addEventListener('scroll', function() {
      const height = this.scrollHeight - this.scrollTop <= this.clientHeight
      if (height) {
        binding.value()
      }
    })
  }
})

// 全局自定义指令 `showtip 判断超出隐藏
Vue.directive('showtip', {
  bind: (el, binding) => {},
  inserted: (el) => {

    const box = el.querySelector('.ellipse-text') || el
    console.log('showtipFunAjx(box):inserted', showtipFunAjx(box))
    if(!showtipFunAjx(box)) {
      try {
        const copyEl = el.parentNode;
        const copySpan = box;
        el.parentNode.removeChild(el);
        copyEl.appendChild(copySpan);
      } catch (error) {
        
      }
    }

  },
  // 所在组件的 VNode 更新时调用，但是可能发生在其子 VNode 更新之前。指令的值可能发生了改变，也可能没有。但是你可以通过比较更新前后的值来忽略不必要的模板更新
  update: (el) => {
    const box = el.querySelector('.ellipse-text') || el
    console.log('showtipFunAjx(box):update', showtipFunAjx(box))
    if(!showtipFunAjx(box)) {
      try {
        const copyEl = el.parentNode;
        const copySpan = box;
        el.parentNode.removeChild(el);
        copyEl.appendChild(copySpan);
      } catch (error) {
        
      }
    }
  },
});

import directives from '@/directive';
// 注册指令服务
for (const key in directives) {
  if (Object.hasOwnProperty.call(directives, key)) {
    const e = directives[key];
    Vue.directive(key, e)
  }
}

import 'jquery'
import './base/css/jquery_ui.css' // 编辑器样式
import './base/css/style_y.css'
import './base/global_event'
import $ from './base/jquery-ui'
import './base/css/1280.scss'
Vue.prototype.$bus = bus

//串号相关,进项目的时候，网页存一下token，后面所有操作都要判断一下，如果和cookie里的token不一样，就是切换过账号了
import Cookies from 'js-cookie'
window.currentWebToken = Cookies.get('dhr-Token');

const myApp = new Vue({
  el: '#app',
  router,
  store,
  axios,
  render: h => h(App)
})

import createFn from '@/utils/log'
import { Api } from '@/api'
Vue.config.errorHandler = function (err, vm, info) {
  console.error(err);
  const p = createFn(err);
  Api.saveProdLog(p)
};